import { retrieveItem } from "@src/helpers/functions";
import { useCheckPageAccess } from "@src/hooks/index";
import {
  AppDispatch,
  getMyOrganization,
  getMyOrganizationRequest,
  Organization } from
"@src/redux";
import { Skeleton } from "antd";
import { startCase } from "lodash";
import React, { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";
import { Menu, menuClasses, MenuItem } from "react-pro-sidebar";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
var pluralize = require("pluralize");

interface CustomSideBarProps {
  sideBarModal: boolean;
  onCloseSideBar: any;
}

const CustomSideBar: React.FC<CustomSideBarProps> = ({
  sideBarModal,
  onCloseSideBar
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuList, setMenuList] = useState<any>([]);
  const { myOrgResult }: {myOrgResult: Organization;} =
  retrieveItem("my_org_result") || {};
  const { id } = useParams();
  const { result: orgResult } = useSelector(getMyOrganization);

  const baseMenuItems = [
  {
    key: "account",
    label: t("my_account"),
    path: "account",
    accessKey: "Account"
  },
  {
    key: "clients",
    label: t("clients"),
    path: "clients",
    accessKey: "Clients"
  },
  {
    key: "devices",
    label: t("devices"),
    path: "devices",
    accessKey: "Devices"
  },
  { key: "sla", label: t("sla"), path: "sla", accessKey: "Sla" },
  { key: "kits", label: t("kits"), path: "kits", accessKey: "Kits" },
  { key: "roles", label: t("roles"), path: "roles", accessKey: "Roles" },
  {
    key: "notifications",
    label: t("notifications"),
    path: "notifications",
    accessKey: "Notifications"
  }];

  const getMenuItems = (): any[] => {
    const items = [...baseMenuItems];
    if (
    myOrgResult?.level?.childLevelList &&
    myOrgResult?.level?.childLevelList?.length > 0 ||
    orgResult?.level?.childLevelList &&
    orgResult?.level?.childLevelList?.length > 0)
    {
      items.splice(4, 0, {
        key: "workers",
        label: pluralize(
          startCase(
            myOrgResult?.level?.childLevelList?.[0]?.name ||
            orgResult?.level?.childLevelList?.[0]?.name
          )
        ),
        path: `org/${id || myOrgResult?.id || orgResult?.id}`,
        accessKey: "Child Organization"
      });
    }
    if (
    myOrgResult?.rootOrganization?.subjectLabel ||
    orgResult?.rootOrganization?.subjectLabel)
    {
      items.splice(5, 0, {
        key: "subjects",
        label: pluralize(
          startCase(
            myOrgResult?.rootOrganization?.subjectLabel ||
            orgResult?.rootOrganization?.subjectLabel
          )
        ),
        path: "subjects",
        accessKey: "Subjects"
      });
    }
    return items;
  };

  useEffect(() => {
    if (orgResult) {
      setMenuList(getMenuItems());
    }
  }, [orgResult, location?.pathname]);

  const handleNavigate = (path: string) => {
    navigate(`/settings/${path}`);
    onCloseSideBar();
  };

  const isActive = (path: string): boolean =>
  location?.state?.breadCrumbs?.length > 0 &&
  location?.pathname?.includes(path) ?
  true :
  location?.pathname?.includes(path);

  if (!myOrgResult) {
    return (
      <div className="menu-container">
        {Array.from({ length: 8 }).map((list) => {
          return <Skeleton.Button style={{ width: "200px" }} active />;
        })}
      </div>);

  }

  return (
    <div>
      <div className="menu_items">
        <span>{t("settings")}</span>
      </div>
      <hr className="drawer-line" />
      <Scrollbars id="sidebar" className="sidebar_content">
        <Menu
          rootStyles={{ ["." + menuClasses.root]: { color: "red" } }}
          menuItemStyles={{
            button: ({ level, active, disabled }) => ({
              color: level === 0 ? "#fff" : disabled ? "#f5d9ff" : "#fff",
              backgroundColor: active ?
              "#313c46" :
              level === 1 && sideBarModal ?
              "#111" :
              "transparent"
            })
          }}>
          
          {menuList?.map((item: any) =>
          useCheckPageAccess(item.accessKey) ?
          <MenuItem
            key={item.key}
            active={isActive(item.path)}
            onClick={() => handleNavigate(item.path)}>
            
                {item.label}
              </MenuItem> :
          null
          )}
        </Menu>
      </Scrollbars>
    </div>);

};

export default CustomSideBar;